// extracted by mini-css-extract-plugin
export default {"layout":"layout___IjS_v","title":"title___NecOZ"};